class VoteManager {
  constructor() {
    this.sessionId = null;
    this.standings = null;
    this.lastUpdate = 0;
    this.sseEnabled = true; // Flag to indicate SSE is available
  }
  
  async initSession(battleId, players, roomId = null) {
    try {
      const apiKey = process.env.REACT_APP_SOULWARS_API_KEY || 'soulwarz';
      
      console.log('🎯 [VoteManager] Initializing session with:', { battleId, playersCount: players.length, players });
      
      const response = await fetch('/api/votes/sessions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': apiKey
        },
        body: JSON.stringify({ battleId, players, roomId })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      this.sessionId = data.sessionId;
      console.log('[VoteManager] Initialized session:', this.sessionId);
      return this.sessionId;
    } catch (error) {
      console.error('[VoteManager] Error initializing session:', error);
      return null;
    }
  }
  
  async getStandings() {
    if (!this.sessionId) return null;
    
    // If SSE is enabled and we have recent data (within 30 seconds), use cache
    if (this.sseEnabled && Date.now() - this.lastUpdate < 30000 && this.standings) {
      return this.standings;
    }
    
    // Fallback to polling if SSE not available or data too old
    try {
      const apiKey = process.env.REACT_APP_SOULWARS_API_KEY || 'soulwarz';
      const response = await fetch(`/api/votes/${this.sessionId}/standings`, {
        headers: { 'X-API-Key': apiKey }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      this.standings = await response.json();
      this.lastUpdate = Date.now();
      return this.standings;
    } catch (error) {
      console.error('[VoteManager] Error getting standings:', error);
      return null;
    }
  }
  
  async closeVoting() {
    if (!this.sessionId) return;
    
    try {
      const apiKey = process.env.REACT_APP_SOULWARS_API_KEY || 'soulwarz';
      const response = await fetch(`/api/votes/${this.sessionId}/close`, {
        method: 'POST',
        headers: { 'X-API-Key': apiKey }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      console.log('[VoteManager] Closed voting for session:', this.sessionId);
    } catch (error) {
      console.error('[VoteManager] Error closing voting:', error);
    }
  }
  
  async getResults() {
    if (!this.sessionId) return null;
    
    try {
      const apiKey = process.env.REACT_APP_SOULWARS_API_KEY || 'soulwarz';
      const response = await fetch(`/api/votes/${this.sessionId}/results`, {
        headers: { 'X-API-Key': apiKey }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('[VoteManager] Error getting results:', error);
      return null;
    }
  }
  
  reset() {
    this.sessionId = null;
    this.standings = null;
    this.lastUpdate = 0;
    console.log('[VoteManager] Reset');
  }
  
  getSessionId() {
    return this.sessionId;
  }

  // Update standings from SSE
  updateStandingsFromSSE(standings) {
    this.standings = standings;
    this.lastUpdate = Date.now();
  }
}

export default new VoteManager();
